(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('CartDrawer');
    var overlay = document.getElementById('CartDrawerOverlay');
    var closeBtn = document.getElementById('CartDrawerClose');
    if (!drawer || !overlay) return;

    /* ── Open / close ── */
    function openDrawer() {
      drawer.hidden = false;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.hidden = true;
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      var openTrigger = document.getElementById('CartDrawerTrigger');
      if (openTrigger) openTrigger.focus();
    }

    overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* Expose globally so header button can call it */
    window.CartDrawer = { open: openDrawer, close: closeDrawer };

    /* ── AJAX cart update ── */
    function refreshDrawer() {
      var body = document.getElementById('CartDrawerBody');
      if (!body) return;
      body.classList.add('is-loading');

      fetch(window.location.pathname + '?section_id=cart-drawer', {
        headers: { 'Accept': 'text/html' }
      })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newDrawer = doc.getElementById('CartDrawer');
          if (newDrawer) {
            drawer.innerHTML = newDrawer.innerHTML;
            rebindDrawerButtons();
          }
          body.classList.remove('is-loading');
        })
        .catch(function () { body.classList.remove('is-loading'); });
    }

    /* ── Qty / remove buttons ── */
    function handleQtyAction(e) {
      var btn = e.target.closest('[data-action]');
      if (!btn || !btn.dataset.line) return;

      var line = parseInt(btn.dataset.line, 10);
      var qty = parseInt(btn.dataset.qty, 10);
      if (isNaN(line) || isNaN(qty)) return;

      var body = document.getElementById('CartDrawerBody');
      if (body) body.classList.add('is-loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: data.item_count } }));
          refreshDrawer();
        })
        .catch(function () {
          if (body) body.classList.remove('is-loading');
        });
    }

    function rebindDrawerButtons() {
      var newClose = document.getElementById('CartDrawerClose');
      if (newClose) newClose.addEventListener('click', closeDrawer);

      var continueBtn = document.getElementById('CartDrawerContinue');
      if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

      var drawerBody = document.getElementById('CartDrawerBody');
      if (drawerBody) drawerBody.addEventListener('click', handleQtyAction);
    }

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    var drawerBody = document.getElementById('CartDrawerBody');
    if (drawerBody) drawerBody.addEventListener('click', handleQtyAction);

    /* ── React to cart:updated ── */
    document.addEventListener('cart:updated', function () {
      refreshDrawer();
    });

    /* ── Open on ATC (dispatched by product form) ── */
    document.addEventListener('cart:open', function () {
      openDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var openBtn = document.getElementById('js-filter-open');
    var closeBtn = document.getElementById('js-filter-close');
    var applyBtn = document.getElementById('js-filter-apply');
    var drawer = document.getElementById('js-filter-drawer');
    var scrim = document.getElementById('js-filter-scrim');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Dual-handle price range slider
    document.querySelectorAll('[data-price-slider]').forEach(function (slider) {
      var form = slider.closest('[data-price-form]');
      var fill = slider.querySelector('[data-range-fill]');
      var minRange = slider.querySelector('[data-range="min"]');
      var maxRange = slider.querySelector('[data-range="max"]');
      var minLabel = slider.querySelector('[data-price-label="min"]');
      var maxLabel = slider.querySelector('[data-price-label="max"]');
      var minInput = form ? form.querySelector('[data-price-input="min"]') : null;
      var maxInput = form ? form.querySelector('[data-price-input="max"]') : null;
      var lo = parseFloat(minRange.min);
      var hi = parseFloat(maxRange.max);

      function pct(v) { return (v - lo) / (hi - lo) * 100; }
      function sync() {
        var a = parseFloat(minRange.value);
        var b = parseFloat(maxRange.value);
        fill.style.left = pct(a) + '%';
        fill.style.right = (100 - pct(b)) + '%';
        if (minLabel) minLabel.textContent = '£' + a;
        if (maxLabel) maxLabel.textContent = '£' + b;
        if (minInput) minInput.value = a;
        if (maxInput) maxInput.value = b;
      }

      minRange.addEventListener('input', function () {
        if (parseFloat(this.value) > parseFloat(maxRange.value)) this.value = maxRange.value;
        sync();
      });
      maxRange.addEventListener('input', function () {
        if (parseFloat(this.value) < parseFloat(minRange.value)) this.value = minRange.value;
        sync();
      });

      sync();
    });

    // Price form submit: multiply £ to pence for Shopify filter API
    document.querySelectorAll('[data-price-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var url = new URL(window.location.href);
        var params = new URLSearchParams(url.search);
        form.querySelectorAll('[data-price-input]').forEach(function (input) {
          var val = parseFloat(input.value);
          if (!isNaN(val) && val > 0) {
            params.set(input.name, Math.round(val * 100));
          } else {
            params.delete(input.name);
          }
        });
        url.search = params.toString();
        window.location.href = url.toString();
      });
    });
    // Horror 18+ banner dismiss
    var ageDismiss = document.getElementById('js-age-dismiss');
    if (ageDismiss) {
      ageDismiss.addEventListener('click', function () {
        var banner = ageDismiss.closest('.coll-pg__age-banner');
        if (banner) banner.style.display = 'none';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  'use strict';

  /* ---- Announcement bar dismiss ---- */
  var announceBar = document.getElementById('announcement-bar');
  var announceClose = document.getElementById('announcement-close');
  if (announceBar && announceClose) {
    if (sessionStorage.getItem('announce-dismissed')) announceBar.hidden = true;
    announceClose.addEventListener('click', function () {
      announceBar.hidden = true;
      sessionStorage.setItem('announce-dismissed', '1');
    });
  }

  /* ---- Mobile nav ---- */
  var menuToggle = document.getElementById('menu-toggle');
  var navOverlay = document.getElementById('nav-overlay');
  var navClose = document.getElementById('nav-close');
  var backdrop = document.getElementById('nav-backdrop');
  var overlayLinks = navOverlay ? navOverlay.querySelectorAll('a, button') : [];

  function openMenu() {
    navOverlay.classList.add('is-open');
    backdrop.classList.add('is-open');
    navOverlay.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    overlayLinks.forEach(function (el) { el.removeAttribute('tabindex'); });
    navClose.focus();
  }
  function closeMenu() {
    navOverlay.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    navOverlay.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    overlayLinks.forEach(function (el) { el.setAttribute('tabindex', '-1'); });
    menuToggle.focus();
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (navClose) navClose.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && navOverlay && navOverlay.classList.contains('is-open')) closeMenu();
  });

  /* ---- Cart count ---- */
  var cartBadge = document.getElementById('cart-count');
  function updateCartCount(count) {
    if (!cartBadge) return;
    if (count > 0) { cartBadge.textContent = count; cartBadge.removeAttribute('hidden'); }
    else { cartBadge.hidden = true; }
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.count === 'number') updateCartCount(e.detail.count);
  });
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (d) { updateCartCount(d.item_count); }).catch(function () {});

  /* ---- Shop mega-menu (desktop hover) ---- */
  var megaTrigger = document.getElementById('mega-trigger');
  var megaTriggerLink = document.getElementById('mega-trigger-link');
  var megaMenu = document.getElementById('mega-menu');
  var megaBackdrop = document.getElementById('mega-backdrop');
  var hideTimer = null;

  function openMega() {
    clearTimeout(hideTimer);
    if (!megaMenu) return;
    megaMenu.classList.add('is-open');
    megaMenu.setAttribute('aria-hidden', 'false');
    if (megaBackdrop) megaBackdrop.classList.add('is-open');
    if (megaTrigger) megaTrigger.classList.add('mega-is-open');
    if (megaTriggerLink) megaTriggerLink.setAttribute('aria-expanded', 'true');
  }

  function closeMega() {
    hideTimer = setTimeout(function () {
      if (!megaMenu) return;
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
      if (megaBackdrop) megaBackdrop.classList.remove('is-open');
      if (megaTrigger) megaTrigger.classList.remove('mega-is-open');
      if (megaTriggerLink) megaTriggerLink.setAttribute('aria-expanded', 'false');
    }, 150);
  }

  if (megaTrigger) {
    megaTrigger.addEventListener('mouseenter', openMega);
    megaTrigger.addEventListener('mouseleave', closeMega);
  }
  if (megaMenu) {
    megaMenu.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    megaMenu.addEventListener('mouseleave', closeMega);
  }
  if (megaBackdrop) {
    megaBackdrop.addEventListener('click', closeMega);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && megaMenu && megaMenu.classList.contains('is-open')) closeMega();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"]) return;
  try {
    
  (function () {
    var productData = null;
    var selectedOptions = [];
    var currentVariant = null;

    function init() {
      var jsonEl = document.getElementById('bpd-variants-json');
      if (!jsonEl) return;
      try { productData = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var variantIdInput = document.getElementById('bpd-variant-id');
      if (variantIdInput) {
        var currentId = parseInt(variantIdInput.value, 10);
        currentVariant = productData.find(function (v) { return v.id === currentId; });
        if (currentVariant) {
          selectedOptions = [currentVariant.option1 || null, currentVariant.option2 || null, currentVariant.option3 || null];
        }
      }
      initThumbnails();
      initQtyStepper();
      initPills();
      initAtcAjax();
    }

    /* ── Thumbnails ── */
    function initThumbnails() {
      var mainImg = document.getElementById('bpd-main-img-el');
      var thumbs = document.querySelectorAll('.bpd__thumb');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (mainImg && btn.dataset.src) { mainImg.src = btn.dataset.src; }
          thumbs.forEach(function (t) { t.classList.remove('bpd__thumb--active'); });
          btn.classList.add('bpd__thumb--active');
        });
      });
    }

    /* ── Qty stepper ── */
    function initQtyStepper() {
      var input = document.getElementById('bpd-qty');
      var minus = document.getElementById('bpd-qty-minus');
      var plus  = document.getElementById('bpd-qty-plus');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10);
        if (v > 1) input.value = v - 1;
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10);
        input.value = v + 1;
      });
    }

    /* ── Variant pills ── */
    function initPills() {
      var pills = document.querySelectorAll('.bpd__tier, .bpd__pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var idx = parseInt(pill.dataset.optionIndex, 10);
          var val = pill.dataset.optionValue;
          selectedOptions[idx] = val;
          var matched = productData.find(function (v) {
            return (!selectedOptions[0] || v.option1 === selectedOptions[0]) &&
                   (!selectedOptions[1] || v.option2 === selectedOptions[1]) &&
                   (!selectedOptions[2] || v.option3 === selectedOptions[2]);
          });
          if (matched) updateVariant(matched);
          document.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (el) {
            el.classList.remove('bpd__tier--active', 'bpd__pill--active');
          });
          pill.classList.add(pill.classList.contains('bpd__tier') ? 'bpd__tier--active' : 'bpd__pill--active');
        });
      });
    }

    function updateVariant(variant) {
      currentVariant = variant;
      var idInput = document.getElementById('bpd-variant-id');
      if (idInput) idInput.value = variant.id;
      var priceEl   = document.getElementById('bpd-price');
      var compareEl = document.getElementById('bpd-compare');
      var saveEl    = document.getElementById('bpd-save-badge');
      var atcBtn    = document.getElementById('bpd-atc');
      var atcText   = document.getElementById('bpd-atc-text');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.classList.remove('bpd__compare--hidden');
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          if (saveEl) { saveEl.textContent = 'Save ' + pct + '%'; saveEl.classList.remove('bpd__save-badge--hidden'); }
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('bpd__compare--hidden');
          if (saveEl) saveEl.classList.add('bpd__save-badge--hidden');
        }
      }
      if (atcBtn && atcText) {
        var addLabel = atcBtn.getAttribute('data-add-text') || 'Add bundle to cart';
        var soldLabel = atcBtn.getAttribute('data-soldout-text') || 'Sold out';
        if (variant.available) {
          atcBtn.disabled = false;
          atcText.textContent = addLabel;
        } else {
          atcBtn.disabled = true;
          atcText.textContent = soldLabel;
        }
      }
    }

    function formatMoney(cents) {
      return '£' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    /* ── AJAX ATC ── */
    function initAtcAjax() {
      var form   = document.getElementById('bpd-form');
      var atcBtn = document.getElementById('bpd-atc');
      var atcText = document.getElementById('bpd-atc-text');
      if (!form || !atcBtn) return;
      var addLabel   = atcBtn.getAttribute('data-add-text') || 'Add bundle to cart';
      var addedLabel = atcBtn.getAttribute('data-added-text') || 'Added!';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcBtn.disabled) return;
        doAddToCart();
      });

      function doAddToCart() {
        var variantId = document.getElementById('bpd-variant-id');
        var qty       = document.getElementById('bpd-qty');
        if (!variantId) return;
        atcBtn.disabled = true;
        if (atcText) atcText.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId.value, 10), quantity: parseInt(qty ? qty.value : 1, 10) })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) { atcBtn.disabled = false; if (atcText) atcText.textContent = addLabel; return; }
            if (atcText) atcText.textContent = addedLabel;
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: data.quantity } }));
            document.dispatchEvent(new CustomEvent('cart:open'));
            setTimeout(function () {
              atcBtn.disabled = false;
              if (atcText) atcText.textContent = addLabel;
            }, 1800);
          })
          .catch(function () { atcBtn.disabled = false; if (atcText) atcText.textContent = addLabel; });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var productData = null;
    var selectedOptions = [];
    var currentVariant = null;

    function init() {
      var jsonEl = document.getElementById('pdp-variants-json');
      if (!jsonEl) return;
      try {
        productData = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }

      var variantIdInput = document.getElementById('pdp-variant-id');
      if (variantIdInput) {
        var currentId = parseInt(variantIdInput.value, 10);
        currentVariant = productData.find(function (v) { return v.id === currentId; });
        if (currentVariant) {
          selectedOptions = [
            currentVariant.option1 || null,
            currentVariant.option2 || null,
            currentVariant.option3 || null
          ];
        }
      }

      initThumbnails();
      initQtyStepper();
      initPills();
      initAtcAjax();
    }

    /* ─── AJAX add-to-cart ─────────────────────────────── */
    function initAtcAjax() {
      var form = document.getElementById('pdp-form');
      var atcBtn = document.getElementById('pdp-atc');
      var atcText = document.getElementById('pdp-atc-text');
      if (!form || !atcBtn) return;

      var addLabel = atcBtn.getAttribute('data-add-text') || 'Add to cart';
      var addedLabel = atcBtn.getAttribute('data-added-text') || 'Added!';
      var pdpEl = document.querySelector('.pdp');
      var isHorror = pdpEl && pdpEl.dataset.isHorror === 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcBtn.disabled) return;

        if (isHorror && window.AgeGate && !window.AgeGate.isConfirmed()) {
          window.AgeGate.open(doAddToCart);
          return;
        }

        doAddToCart();
      });

      function doAddToCart() {
        var formData = new FormData(form);
        atcBtn.disabled = true;
        if (atcText) atcText.textContent = addedLabel;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
            document.dispatchEvent(new CustomEvent('cart:open'));
            setTimeout(function () {
              atcBtn.disabled = false;
              if (atcText) {
                var price = currentVariant ? ' · ' + formatMoney(currentVariant.price) : '';
                atcText.textContent = addLabel + price;
              }
            }, 1200);
          })
          .catch(function () {
            atcBtn.disabled = false;
            if (atcText) atcText.textContent = addLabel;
            form.submit();
          });
      }
    }

    /* ─── Thumbnails ──────────────────────────────────── */
    function initThumbnails() {
      var thumbs = document.querySelectorAll('.pdp__thumb');
      if (!thumbs.length) return;

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-src');
          if (!src) return;
          var imgEl = document.getElementById('pdp-main-img-el');
          if (!imgEl) return;
          imgEl.style.opacity = '0';
          imgEl.setAttribute('src', src);
          imgEl.onload = function () {
            imgEl.style.opacity = '1';
          };
          thumbs.forEach(function (t) { t.classList.remove('pdp__thumb--active'); });
          btn.classList.add('pdp__thumb--active');
        });
      });
    }

    /* ─── Quantity stepper ────────────────────────────── */
    function initQtyStepper() {
      var input = document.getElementById('pdp-qty');
      var minus = document.getElementById('pdp-qty-minus');
      var plus = document.getElementById('pdp-qty-plus');
      if (!input || !minus || !plus) return;

      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });

      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (val < 99) input.value = val + 1;
      });

      input.addEventListener('change', function () {
        var val = parseInt(input.value, 10);
        if (isNaN(val) || val < 1) input.value = 1;
        if (val > 99) input.value = 99;
      });
    }

    /* ─── Pill / tier selection ───────────────────────── */
    function initPills() {
      var pills = document.querySelectorAll('.pdp__pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.classList.contains('pdp__pill--soldout')) return;
          var optionIndex = parseInt(pill.getAttribute('data-option-index'), 10);
          var optionValue = pill.getAttribute('data-option-value');
          selectedOptions[optionIndex] = optionValue;

          var group = pill.closest('.pdp__pills, .pdp__tiers');
          if (group) {
            group.querySelectorAll('.pdp__pill').forEach(function (p) {
              p.classList.remove('pdp__pill--active');
            });
          }
          pill.classList.add('pdp__pill--active');

          var radio = pill.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;

          syncVariant();
        });
      });
    }

    function syncVariant() {
      if (!productData) return;

      var matched = null;
      productData.forEach(function (variant) {
        if (matched) return;
        var o1 = selectedOptions[0] === null || variant.option1 === selectedOptions[0];
        var o2 = selectedOptions[1] === null || variant.option2 === selectedOptions[1];
        var o3 = selectedOptions[2] === null || variant.option3 === selectedOptions[2];
        if (o1 && o2 && o3) matched = variant;
      });

      if (!matched) return;
      currentVariant = matched;

      var idInput = document.getElementById('pdp-variant-id');
      if (idInput) idInput.value = matched.id;

      updatePrice(matched);
      updateAtcButton(matched);
    }

    function formatMoney(cents) {
      if (cents === null || cents === undefined) return '';
      var pounds = cents / 100;
      return '£' + (pounds % 1 === 0 ? pounds.toFixed(0) : pounds.toFixed(2));
    }

    function updatePrice(variant) {
      var priceEl = document.getElementById('pdp-price');
      var compareEl = document.getElementById('pdp-compare');
      var saveEl = document.getElementById('pdp-save-badge');

      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (compareEl && saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.classList.remove('pdp__compare--hidden');
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.classList.remove('pdp__save-badge--hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('pdp__compare--hidden');
          saveEl.textContent = '';
          saveEl.classList.add('pdp__save-badge--hidden');
        }
      }
    }

    function updateAtcButton(variant) {
      var btn = document.getElementById('pdp-atc');
      var txt = document.getElementById('pdp-atc-text');
      if (!btn || !txt) return;
      if (variant.available) {
        btn.disabled = false;
        txt.textContent = (btn.getAttribute('data-add-text') || 'Add to cart') + ' · ' + formatMoney(variant.price);
      } else {
        btn.disabled = true;
        txt.textContent = btn.getAttribute('data-soldout-text') || 'Sold out';
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support"]) return;
  try {
    
  (function() {
    var tabs = document.querySelectorAll('.sp__tab');
    var panels = document.querySelectorAll('.sp__panel');
    var searchInput = document.getElementById('sp-search');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var cat = tab.dataset.category;
        tabs.forEach(function(t) { t.classList.remove('sp__tab--active'); });
        tab.classList.add('sp__tab--active');
        panels.forEach(function(p) {
          p.classList.toggle('sp__panel--active', p.dataset.panel === cat);
        });
        if (searchInput) searchInput.value = '';
        panels.forEach(function(p) {
          p.querySelectorAll('.sp__accordion').forEach(function(a) { a.style.display = ''; });
        });
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        var q = searchInput.value.toLowerCase().trim();
        if (!q) {
          panels.forEach(function(p) {
            p.querySelectorAll('.sp__accordion').forEach(function(a) { a.style.display = ''; });
          });
          return;
        }
        var firstActive = null;
        panels.forEach(function(p) {
          var hasVisible = false;
          p.querySelectorAll('.sp__accordion').forEach(function(a) {
            var show = a.textContent.toLowerCase().includes(q);
            a.style.display = show ? '' : 'none';
            if (show) hasVisible = true;
          });
          if (hasVisible && !firstActive) firstActive = p.dataset.panel;
        });
        if (firstActive) {
          panels.forEach(function(p) { p.classList.toggle('sp__panel--active', p.dataset.panel === firstActive); });
          tabs.forEach(function(t) { t.classList.toggle('sp__tab--active', t.dataset.category === firstActive); });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form    = document.getElementById('track-form');
    var submit  = document.getElementById('track-submit');
    var errorEl = document.getElementById('track-error');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var orderInput = form.querySelector('[name="order_number"]');
      var emailInput = form.querySelector('[name="email"]');
      var valid = true;

      if (errorEl) errorEl.hidden = true;

      if (orderInput && orderInput.value.trim() === '') {
        orderInput.focus();
        valid = false;
      }
      if (emailInput && emailInput.value.trim() === '') {
        if (valid) emailInput.focus();
        valid = false;
      }

      if (!valid) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = false;
        return;
      }

      /* Strip leading # if customer typed it */
      if (orderInput) {
        orderInput.value = orderInput.value.replace(/^#/, '').trim();
      }

      if (submit) submit.disabled = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
